import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-full bg-[#0F1923] text-white/70 border-t border-white/10" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-3">
              <img src="/odesie-logo-white.png" alt="Odesie" className="h-8 w-auto" />
            </div>
            <p className="text-sm leading-relaxed">
              Powered by Technology Transfer Services, LLC. Empowering workforce development through structured training.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-3 uppercase tracking-wider">Platform</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/admin/catalog" className="hover:text-white transition-colors">Course Catalog</Link></li>
              <li><Link to="/admin/learning-paths" className="hover:text-white transition-colors">Learning Paths</Link></li>
              <li><Link to="/admin/sessions" className="hover:text-white transition-colors">ILT Sessions</Link></li>
              <li><Link to="/admin/assessments" className="hover:text-white transition-colors">Assessments</Link></li>
              <li><Link to="/admin/compliances" className="hover:text-white transition-colors">Compliance</Link></li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-3 uppercase tracking-wider">Solutions</h4>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-white transition-colors cursor-default">Manufacturing Training</li>
              <li className="hover:text-white transition-colors cursor-default">Power Generation</li>
              <li className="hover:text-white transition-colors cursor-default">Water Treatment</li>
              <li className="hover:text-white transition-colors cursor-default">Safety & Compliance</li>
              <li className="hover:text-white transition-colors cursor-default">Custom Course Design</li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-3 uppercase tracking-wider">Support</h4>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-white transition-colors cursor-default">Help Center</li>
              <li className="hover:text-white transition-colors cursor-default">Contact Support</li>
              <li className="hover:text-white transition-colors cursor-default">System Status</li>
              <li className="hover:text-white transition-colors cursor-default">Privacy Policy</li>
              <li className="hover:text-white transition-colors cursor-default">Terms of Service</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs">&copy; {new Date().getFullYear()} Technology Transfer Services, LLC. All rights reserved.</p>
          <div className="flex items-center gap-4 text-xs">
            <span className="text-white/50">Odesie - Powered by Technology Transfer Services, LLC</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
